import { BookingOnboardingDto, UpdateBookingOnboardingDto } from '@shared/core/booking-onboarding'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { GET_PROVIDER_DETAILS_CACHE_KEY } from 'src/modules/booking/hooks/use-availability-slots'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { useProfile } from 'src/modules/user/hooks/use-profile'
import { BookingOnboardingService } from 'src/services/booking-onboarding.service'

export const GET_BOOKING_ONBOARDING_CACHE_KEY = 'get-booking-onboarding'
export const UPDATE_BOOKING_ONBOARDING_CACHE_KEY = 'update-booking-onboarding'

export function useBookingOnboarding(options?: UseQueryOptions<BookingOnboardingDto>) {
  const handleRetry = useHandleRetry()

  return useQuery([GET_BOOKING_ONBOARDING_CACHE_KEY], () => BookingOnboardingService.get(), {
    staleTime: 300000,
    retry: handleRetry,
    ...options,
  })
}

export function useUpdateBookingOnboarding() {
  const queryClient = useQueryClient()
  const { data: profile } = useProfile()

  return useMutation(
    UPDATE_BOOKING_ONBOARDING_CACHE_KEY,
    (updateDto: UpdateBookingOnboardingDto) => BookingOnboardingService.update(updateDto),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([GET_BOOKING_ONBOARDING_CACHE_KEY])
        if ('booking_page_name' in variables && profile?.id) {
          queryClient.invalidateQueries([GET_PROVIDER_DETAILS_CACHE_KEY, profile.id])
        }
      },
    },
  )
}
